import React from "react";

import { Box, Popover, MenuItem, Typography, Modal } from "@mui/material";
import Field from "../common/Field/Fi";
import Button from "../common/Button/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useMediaQuery from "@mui/material/useMediaQuery";
import FilterListIcon from "@mui/icons-material/FilterList";
import sort from "../../assets/svgs/sort.svg";
import SearchField from "../common/SearchField/SearchField";
import YearSelect from "../common/YearSelect/YearSelect";
import MakeModel from "../common/CheckMarkSelect/MakeModel";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import StaticDatePicker from "@mui/lab/StaticDatePicker";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
function AuctionPageTopBar({
  toggleDrawerFilter,
  toggleDrawerSort,
  val,
  handleChange,
  resetFilters,
  setShowMoreFilterModal,
}) {
  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = React.useState(false);
  const [calenderValue, setCalenderValue] = React.useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   console.log(event);
  //   setAnchorEl(event.target);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const open = Boolean(anchorEl);
  // const id = open ? "auction-calender" : undefined;
  console.log(calenderValue, "calenderValue");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        margin: { xs: "16px", sm: "16px 24px" },
        columnGap: { xs: "auto", md: "10px" },
        justifyContent: "center",
        marginTop: { xs: "0", md: "15px" },
        marginBottom: { xs: "16px", sm: "10px", md: "16px" },
      }}
    >
      {mobMatch ? (
        <>
          <SearchField label="Category, Make or Model" />
          <Box
            sx={{
              display: "flex",
              marginTop: "16px",
              marginBottom: "7px",
              justifyContent: "space-between",
            }}
          >
            <MobButtons
              onClick={toggleDrawerFilter(true)}
              text="Filters"
              icon={
                <FilterListIcon
                  sx={{
                    color: "#1F1F1F",
                    width: "15px",
                    height: "15px",
                    marginRight: "4px",
                  }}
                />
              }
            />
            <MobButtons
              onClick={toggleDrawerSort(true)}
              text="Sort by"
              icon={
                <img
                  src={sort}
                  alt="sort"
                  style={{ color: "#1F1F1F", marginRight: "4px" }}
                />
              }
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            columnGap: "10px",
            width: "100%",
            justifyContent: { xs: "center", xl: "center" },
          }}
        >
          <SearchField
            sx={{ width: "100%" }}
            label="Category, Make or Model"
            resetFilter={resetFilters}
          />

          {/* <Popover
            id={id}
            open={open}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={{ top: 150, left:1000 }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Box sx={{ width: "328px !important" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <StaticDatePicker
                  displayStaticWrapperAs="desktop"
                  // label="Week picker"
                  // value={value}
                  // onChange={(newValue) => {
                  //   setValue(newValue);
                  // }}
                  // renderDay={renderWeekPickerDay}
                  // renderInput={(params) => <TextField {...params} />}
                  // inputFormat="'Week of' MMM d"
                />
              </LocalizationProvider>
            </Box>
          </Popover> */}
          <Field
            height="46.29px"
            label="When"
            value={val}
            handleChange={handleChange}
            sx={{ width: "182px", position: "relative" }}
            select={true}
          >
            <MenuItem key={0} value={"pro"}>
              Any day
            </MenuItem>
            <MenuItem key={1} value={"buy"}>
              This week
            </MenuItem>
            <MenuItem key={2} value={"auction"}>
              This weekend
            </MenuItem>
            <MenuItem key={3} value={"auction"}>
              Next week
            </MenuItem>
            <MenuItem onClick={handleOpen} key={4} value={"auction"}>
              Custom
            </MenuItem>
          </Field>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            BackdropComponent={null}
            sx={{
              top: 150,
              left: { md: "65%", lg: "75%", xl: "85%" },
              // right: 0,
              height: "fit-content",
              width: "328px",
              boxShadow:
                "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
              borderRadius: "8px",
              background: "#fff",
            }}
          >
            <>
              <Box
                sx={{
                  width: "328px !important",
                  "& .PrivatePickersSlideTransition-root": {
                    minHeight: "auto",
                    height: "200px",
                  },
                  "& .MuiButtonBase-root.MuiPickersDay-root.MuiPickersDay-today":
                    {
                      backgroundColor: "#fff",
                      border: "2px solid #255CCE",
                      color: "text.primary",
                    },
                  "& .MuiButtonBase-root.MuiPickersDay-root.Mui-selected": {
                    backgroundColor: "#255CCE",
                    color: "#fff",
                    borderTopLeftRadius: "50%",
                    borderBottomLeftRadius: "50%",
                  },
                }}
              >
                <Box
                  sx={{
                    height: "72px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderBottom: "1px solid #D6D6D6",
                  }}
                >
                  <ArrowBackIcon
                    onClick={handleClose}
                    sx={{
                      position: "absolute",
                      fontSize: "24px",
                      color: "primary.main",
                      left: 24,
                      cursor: "pointer",
                    }}
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{ fontSize: "16px", lineHeight: "24px" }}
                  >
                    Pick a date
                  </Typography>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <StaticDatePicker
                    displayStaticWrapperAs="desktop"
                    value={calenderValue}
                    onChange={(newValue) => {
                      setCalenderValue(newValue);
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box
                sx={{
                  height: "97px",
                  padding: "24px",
                  borderTop: "1px solid #D6D6D6",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  columnGap: "24px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "600",
                    textDecorationLine: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => setCalenderValue("")}
                >
                  Reset
                </Typography>
                <Button
                  variant="contained"
                  bgColor="#F9D548"
                  txColor="text.primary"
                  size="lg"
                  sx={{
                    height: "48px !important",
                    width: "99px",
                    boxShadow: "none",
                  }}
                  typoVariant="subtitle1"
                  typoSize={16}
                  hoverBg="#F3C04F"
                  onClick={handleClose}
                >
                  Save
                </Button>
              </Box>
            </>
          </Modal>
          {/* <Box
            sx={{
              width: "182px",
              display: "flex",
              height: "46.29px",
              border: "1px solid #C7C7C7",
              borderRadius: "3px",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "11px 13px",
              "&:hover": {
                cursor: "pointer",
              },
            }}
            onClick={() => setShowMoreFilterModal(true)}
          >
            <Typography
              variant="body1"
              color="#616161"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
            >
              More
            </Typography>
            <KeyboardArrowDownIcon sx={{ color: "#808080" }} />
          </Box> */}
          <Button
            variant="contained"
            bgColor="#F9D548"
            txColor="text.primary"
            size="lg"
            sx={{
              height: "46px !important",
              width: "128px",
              boxShadow: "none",
            }}
            hoverBg="#F3C04F"
          >
            Search
          </Button>
        </Box>
      )}
    </Box>
  );
}

function MobButtons({ text, icon, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        width: "47.7%",
        height: "36px",
        border: "1px solid #BFBFBF",
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        padding: "8px auto",
      }}
    >
      {icon}
      <Typography
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="text.primary"
      >
        {text}
      </Typography>
    </Box>
  );
}

export default AuctionPageTopBar;
